// extracted by mini-css-extract-plugin
export default {"section":"RedirectAfterAuth_section__l9EnF"};